import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "./pages/Landing";
import Disclosures from "./pages/Disclosures";
import Designs from "./pages/Designs";
import Monolith from "./pages/designs/Monolith";
import Obsidian from "./pages/designs/Obsidian";
import Bedrock from "./pages/designs/Bedrock";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/disclosures" element={<Disclosures />} />
          <Route path="/designs" element={<Designs />} />
          <Route path="/design/monolith" element={<Monolith />} />
          <Route path="/design/obsidian" element={<Obsidian />} />
          <Route path="/design/bedrock" element={<Bedrock />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
